(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mj-video-filter-fixes"] && !Shopify.designMode) return;
  try {
    (function() {
    function primeVideo(video) {
      if (!video || video.preload === 'metadata' || video.preload === 'auto') {
        return;
      }
      video.preload = 'metadata';
    }

    function formatVideoTime(value) {
      var seconds = Number.isFinite(value) ? Math.max(0, Math.floor(value)) : 0;
      var minutes = Math.floor(seconds / 60);
      var remainder = String(seconds % 60).padStart(2, '0');
      return minutes + ':' + remainder;
    }

    function createDesktopVideoControls(video) {
      if (video.dataset.mjCustomControls === 'true') {
        return video.parentElement.querySelector('.mj-video-controls');
      }

      var wrapper = video.closest('.product__video-wrapper');
      if (!wrapper) {
        return null;
      }

      var controls = document.createElement('div');
      controls.className = 'mj-video-controls';
      controls.setAttribute('role', 'group');
      controls.setAttribute('aria-label', 'Video controls');
      controls.innerHTML = '<button type="button" class="mj-video-control mj-video-toggle" aria-label="Pause product video"><svg data-icon="play" viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5.5 18 12 8 18.5Z"></path></svg><svg data-icon="pause" viewBox="0 0 24 24" aria-hidden="true"><path d="M9 6v12M15 6v12"></path></svg></button><div class="mj-video-scrub"><input class="mj-video-range mj-video-progress" type="range" min="0" max="1000" step="1" value="0" aria-label="Video progress"><span class="mj-video-time" aria-hidden="true">0:00 / 0:00</span></div><button type="button" class="mj-video-control mj-video-fullscreen" aria-label="Enter fullscreen"><svg data-icon="fullscreen-enter" viewBox="0 0 24 24" aria-hidden="true"><path d="M8 4H4v4M16 4h4v4M20 16v4h-4M4 16v4h4"></path></svg><svg data-icon="fullscreen-exit" viewBox="0 0 24 24" aria-hidden="true"><path d="M4 9h5V4M15 4v5h5M20 15h-5v5M9 20v-5H4"></path></svg></button>';
      wrapper.appendChild(controls);
      video.dataset.mjCustomControls = 'true';

      var toggle = controls.querySelector('.mj-video-toggle');
      var progress = controls.querySelector('.mj-video-progress');
      var time = controls.querySelector('.mj-video-time');
      var fullscreen = controls.querySelector('.mj-video-fullscreen');

      function updatePlayState() {
        var isPlaying = !video.paused && !video.ended;
        toggle.dataset.state = isPlaying ? 'playing' : 'paused';
        toggle.setAttribute('aria-label', isPlaying ? 'Pause product video' : 'Play product video');
      }

      function updateTimeline() {
        var duration = Number.isFinite(video.duration) ? video.duration : 0;
        var ratio = duration ? video.currentTime / duration : 0;
        progress.value = String(Math.round(ratio * 1000));
        progress.style.setProperty('--mj-progress', Math.round(ratio * 100) + '%');
        time.textContent = formatVideoTime(video.currentTime) + ' / ' + formatVideoTime(duration);
      }

      function positionControls() {
        if (!window.matchMedia('(min-width: 770px)').matches || !video.videoWidth || !video.videoHeight) {
          controls.style.removeProperty('--mj-video-controls-bottom');
          return;
        }
        var bounds = wrapper.getBoundingClientRect();
        var mediaRatio = video.videoWidth / video.videoHeight;
        var wrapperRatio = bounds.width / bounds.height;
        var contentHeight = mediaRatio > wrapperRatio ? bounds.width / mediaRatio : bounds.height;
        var lowerLetterbox = Math.max(0, (bounds.height - contentHeight) / 2);
        controls.style.setProperty('--mj-video-controls-bottom', Math.round(lowerLetterbox + 16) + 'px');
      }

      function updateFullscreen() {
        var isFullscreen = document.fullscreenElement === wrapper;
        fullscreen.dataset.state = isFullscreen ? 'fullscreen' : 'windowed';
        fullscreen.setAttribute('aria-label', isFullscreen ? 'Exit fullscreen' : 'Enter fullscreen');
        window.requestAnimationFrame(positionControls);
      }

      function togglePlayback() {
        if (video.paused) {
          var playAttempt = video.play();
          if (playAttempt && typeof playAttempt.catch === 'function') {
            playAttempt.catch(function() {});
          }
        } else {
          video.pause();
        }
      }

      controls.addEventListener('click', function(event) {
        event.stopPropagation();
      });

      controls.addEventListener('pointerdown', function(event) {
        event.stopPropagation();
      });

      toggle.addEventListener('click', togglePlayback);

      progress.addEventListener('input', function() {
        if (Number.isFinite(video.duration) && video.duration > 0) {
          video.currentTime = Number(progress.value) / 1000 * video.duration;
          updateTimeline();
        }
      });

      fullscreen.addEventListener('click', function() {
        if (document.fullscreenElement === wrapper) {
          document.exitFullscreen();
        } else if (wrapper.requestFullscreen) {
          wrapper.requestFullscreen();
        } else if (video.webkitEnterFullscreen) {
          video.webkitEnterFullscreen();
        }
      });

      video.addEventListener('play', updatePlayState);
      video.addEventListener('pause', updatePlayState);
      video.addEventListener('ended', updatePlayState);
      video.addEventListener('timeupdate', updateTimeline);
      video.addEventListener('loadedmetadata', updateTimeline);
      video.addEventListener('loadedmetadata', positionControls);
      video.addEventListener('durationchange', updateTimeline);
      document.addEventListener('fullscreenchange', updateFullscreen);
      window.addEventListener('resize', positionControls, { passive: true });

      updatePlayState();
      updateTimeline();
      updateFullscreen();
      positionControls();
      return controls;
    }

    function enhanceGallery(gallery) {
      if (!gallery || gallery.dataset.mjVideoEnhanced === 'true') {
        return;
      }

      var slides = gallery.querySelectorAll('.product-main-slide');
      var hasVideo = false;

      slides.forEach(function(slide) {
        var video = slide.querySelector('video.product__video');
        if (!video) {
          return;
        }

        hasVideo = true;

        function isDesktopVideo() {
          return window.matchMedia('(min-width: 770px)').matches;
        }

        function syncVideoControlMode() {
          if (isDesktopVideo()) {
            createDesktopVideoControls(video);
            video.controls = false;
            video.removeAttribute('controls');
            video.setAttribute('tabindex', '0');
            video.setAttribute('role', 'button');
            video.setAttribute('aria-label', video.paused ? 'Play product video' : 'Pause product video');
          } else {
            video.controls = true;
            video.setAttribute('controls', '');
            video.removeAttribute('tabindex');
            video.removeAttribute('role');
            video.removeAttribute('aria-label');
          }
        }

        function toggleDesktopVideo(event) {
          if (!isDesktopVideo()) {
            return;
          }
          if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') {
            return;
          }
          if (event.type === 'keydown') {
            event.preventDefault();
          }
          if (video.paused) {
            var playAttempt = video.play();
            if (playAttempt && typeof playAttempt.catch === 'function') {
              playAttempt.catch(function() {});
            }
          } else {
            video.pause();
          }
        }

        if (video.dataset.mjDesktopControlBound !== 'true') {
          video.dataset.mjDesktopControlBound = 'true';
          video.addEventListener('click', toggleDesktopVideo);
          video.addEventListener('keydown', toggleDesktopVideo);
          video.addEventListener('play', syncVideoControlMode);
          video.addEventListener('pause', syncVideoControlMode);
          window.addEventListener('resize', syncVideoControlMode, { passive: true });
        }
        syncVideoControlMode();

        var index = slide.getAttribute('data-index');
        var labelImage = slide.querySelector('img[alt]');
        var label = labelImage && labelImage.alt ? labelImage.alt : video.getAttribute('aria-label');
        var thumb = gallery.querySelector('.product__thumb-item[data-index="' + index + '"]');

        if (thumb) {
          thumb.classList.add('mj-video-thumb');
          thumb.addEventListener('pointerenter', function() { primeVideo(video); }, { once: true });
          thumb.addEventListener('focusin', function() { primeVideo(video); }, { once: true });
        }

        function decorateDot() {
          var dots = gallery.querySelectorAll('.flickity-page-dots .dot');
          var dot = dots[Number(index)];
          if (!dot || dot.classList.contains('mj-video-dot')) {
            return;
          }
          dot.classList.add('mj-video-dot');
          if (label) {
            dot.setAttribute('aria-label', label);
          }
          dot.addEventListener('pointerenter', function() { primeVideo(video); }, { once: true });
          dot.addEventListener('focusin', function() { primeVideo(video); }, { once: true });
          dot.addEventListener('pointerdown', function() { primeVideo(video); }, { once: true });
        }

        window.setTimeout(decorateDot, 250);

        if ('MutationObserver' in window) {
          var dotObserver = new MutationObserver(decorateDot);
          dotObserver.observe(gallery, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
        }
      });

      if (hasVideo) {
        gallery.dataset.mjVideoEnhanced = 'true';
      }
    }

    function init() {
      document.querySelectorAll('[data-product-images]').forEach(enhanceGallery);
    }

    var facetRefreshTimer;
    var facetRefreshController;
    var desktopFilterScrollKey = 'mjDesktopFilterScroll';
    var pendingDesktopFilterScroll;
    var desktopFilterOriginalBodyMinHeight;
    var desktopFilterHeightLocked = false;
    var reopenMobileFilterDrawerAfterClear = false;
    var nativeDesktopScrollTo = window.scrollTo.bind(window);

    window.scrollTo = function() {
      var options = arguments[0];
      if (
        typeof pendingDesktopFilterScroll === 'number' &&
        window.matchMedia('(min-width: 769px)').matches &&
        options &&
        typeof options === 'object' &&
        options.behavior === 'smooth'
      ) {
        return;
      }
      return nativeDesktopScrollTo.apply(window, arguments);
    };

    function lockDesktopFilterHeight(minimumHeight) {
      if (!window.matchMedia('(min-width: 769px)').matches || !document.body) {
        return;
      }
      if (!desktopFilterHeightLocked) {
        desktopFilterOriginalBodyMinHeight = document.body.style.minHeight;
      }
      var pageHeight = Math.max(
        Number(minimumHeight) || 0,
        document.documentElement.scrollHeight,
        document.body.scrollHeight
      );
      document.body.style.minHeight = pageHeight + 'px';
      desktopFilterHeightLocked = true;
    }

    function releaseDesktopFilterHeight() {
      if (!desktopFilterHeightLocked || !document.body) {
        return;
      }
      document.body.style.minHeight = desktopFilterOriginalBodyMinHeight || '';
      desktopFilterOriginalBodyMinHeight = undefined;
      desktopFilterHeightLocked = false;
    }

    function hasActiveCollectionFilters() {
      return Array.from(new URL(window.location.href).searchParams.keys()).some(function(key) {
        return key.indexOf('filter.') === 0;
      });
    }

    function setDesktopFilterScroll(position) {
      var root = document.documentElement;
      var previousBehavior = root.style.getPropertyValue('scroll-behavior');
      var previousPriority = root.style.getPropertyPriority('scroll-behavior');
      root.style.setProperty('scroll-behavior', 'auto', 'important');
      nativeDesktopScrollTo({ top: position, left: 0, behavior: 'auto' });
      window.requestAnimationFrame(function() {
        if (previousBehavior) {
          root.style.setProperty('scroll-behavior', previousBehavior, previousPriority);
        } else {
          root.style.removeProperty('scroll-behavior');
        }
      });
    }

    function rememberDesktopFilterScroll() {
      if (!window.matchMedia('(min-width: 769px)').matches) {
        return;
      }
      try {
        pendingDesktopFilterScroll = window.scrollY;
        var pageHeight = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight);
        lockDesktopFilterHeight(pageHeight);
        window.sessionStorage.setItem(desktopFilterScrollKey, JSON.stringify({
          path: window.location.pathname,
          position: window.scrollY,
          height: pageHeight,
          savedAt: Date.now()
        }));
      } catch (error) {
        return;
      }
    }

    function restoreDesktopFilterScroll() {
      var saved;
      try {
        saved = JSON.parse(window.sessionStorage.getItem(desktopFilterScrollKey));
      } catch (error) {
        return;
      }
      if (!saved || saved.path !== window.location.pathname || Date.now() - saved.savedAt > 10000) {
        return;
      }
      window.sessionStorage.removeItem(desktopFilterScrollKey);
      lockDesktopFilterHeight(saved.height);
      var scheduleRestore = function() {
        var restore = function() {
          setDesktopFilterScroll(saved.position);
        };
        restore();
        window.setTimeout(restore, 80);
        window.setTimeout(restore, 260);
      };
      if (document.readyState === 'complete') {
        scheduleRestore();
      } else {
        window.addEventListener('load', scheduleRestore, { once: true });
      }
    }

    function stagedFilterUrl(form) {
      var url = new URL(window.location.href);
      Array.from(url.searchParams.keys()).forEach(function(key) {
        if (key.indexOf('filter.') === 0 || key === 'page') {
          url.searchParams.delete(key);
        }
      });
      new FormData(form).forEach(function(value, key) {
        if (value !== '') {
          url.searchParams.append(key, value);
        }
      });
      return url;
    }

    function copyFacetState(form, sourceForm) {
      form.querySelectorAll('input[name]').forEach(function(input) {
        var sourceInput = Array.from(sourceForm.querySelectorAll('input[name]')).find(function(candidate) {
          return candidate.name === input.name && candidate.value === input.value;
        });
        var item = input.closest('.tag');

        if (!sourceInput) {
          if (item && !input.checked) {
            item.classList.add('hide');
          }
          return;
        }

        var sourceItem = sourceInput.closest('.tag');
        var labelContent = input.closest('label') && input.closest('label').querySelector(':scope > span:last-child');
        var sourceLabelContent = sourceInput.closest('label') && sourceInput.closest('label').querySelector(':scope > span:last-child');

        if (item && sourceItem) {
          item.className = sourceItem.className;
        }
        if (labelContent && sourceLabelContent) {
          labelContent.innerHTML = sourceLabelContent.innerHTML;
        }
      });

      var activeTags = form.parentElement.querySelector('.tag-list--active-tags');
      var sourceActiveTags = sourceForm.parentElement.querySelector('.tag-list--active-tags');
      if (activeTags && sourceActiveTags) {
        activeTags.innerHTML = sourceActiveTags.innerHTML;
      }
    }

    function refreshFacetCounts(form) {
      window.clearTimeout(facetRefreshTimer);
      facetRefreshTimer = window.setTimeout(function() {
        if (facetRefreshController) {
          facetRefreshController.abort();
        }
        facetRefreshController = new AbortController();
        form.setAttribute('aria-busy', 'true');

        fetch(stagedFilterUrl(form).toString(), {
          credentials: 'same-origin',
          headers: { Accept: 'text/html' },
          signal: facetRefreshController.signal
        })
          .then(function(response) {
            if (!response.ok) {
              throw new Error(String(response.status));
            }
            return response.text();
          })
          .then(function(html) {
            var page = new DOMParser().parseFromString(html, 'text/html');
            var sourceForm = page.querySelector('#FilterDrawer .mj-filter-form--staged');
            if (sourceForm) {
              copyFacetState(form, sourceForm);
            }
          })
          .catch(function(error) {
            if (error.name !== 'AbortError') {
              form.removeAttribute('aria-busy');
            }
          })
          .finally(function() {
            form.removeAttribute('aria-busy');
          });
      }, 180);
    }

    document.addEventListener('input', function(event) {
      if (event.target.closest('#CollectionSidebar .filter-form')) {
        rememberDesktopFilterScroll();
      }
    }, true);

    document.addEventListener('change', function(event) {
      var form = event.target.closest('#FilterDrawer .mj-filter-form--staged');
      if (form) {
        event.stopImmediatePropagation();
        refreshFacetCounts(form);
      }
    }, true);

    document.addEventListener('click', function(event) {
      if (event.target.closest('#CollectionSidebar .tag-list--active-tags a')) {
        rememberDesktopFilterScroll();
      }
      if (event.target.closest('#FilterDrawer .mj-filter-form--staged .tag__checkbox-wrapper')) {
        event.stopImmediatePropagation();
      }

      var clearButton = event.target.closest('#FilterDrawer .mj-filter-actions__clear');
      if (clearButton) {
        event.preventDefault();
        event.stopImmediatePropagation();
        var form = clearButton.closest('.mj-filter-form--staged');
        form.querySelectorAll('input[type="checkbox"], input[type="radio"]').forEach(function(input) {
          input.checked = false;
        });
        form.querySelectorAll('input[type="text"], input[type="number"]').forEach(function(input) {
          input.value = '';
        });
        var activeTags = form.parentElement.querySelector('.tag-list--active-tags');
        if (activeTags) {
          activeTags.innerHTML = '';
        }

        if (!hasActiveCollectionFilters()) {
          refreshFacetCounts(form);
          return;
        }

        var nativeForm = document.querySelector('#CollectionSidebar .collection-sidebar .filter-form');
        var nativeInput = nativeForm && (nativeForm.querySelector('input:checked') || nativeForm.querySelector('input[name]'));
        if (!nativeForm || !nativeInput) {
          window.location.assign(clearButton.href);
          return;
        }

        nativeForm.querySelectorAll('input[type="checkbox"], input[type="radio"]').forEach(function(input) {
          input.checked = false;
        });
        nativeForm.querySelectorAll('input[type="text"], input[type="number"]').forEach(function(input) {
          input.value = '';
        });
        reopenMobileFilterDrawerAfterClear = true;
        nativeInput.dispatchEvent(new Event('input', { bubbles: true }));
      }

      var activeTag = event.target.closest('#FilterDrawer .tag-list--active-tags a');
      if (activeTag) {
        event.preventDefault();
        event.stopImmediatePropagation();
        var activeForm = activeTag.closest('.drawer__scrollable').querySelector('.mj-filter-form--staged');
        var activeUrl = new URL(activeTag.href, window.location.href);
        activeForm.querySelectorAll('input[name]').forEach(function(input) {
          input.checked = activeUrl.searchParams.getAll(input.name).indexOf(input.value) !== -1;
        });
        refreshFacetCounts(activeForm);
      }
    }, true);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    restoreDesktopFilterScroll();
    document.addEventListener('collection:reloaded', function() {
      if (reopenMobileFilterDrawerAfterClear && window.matchMedia('(max-width: 768px)').matches) {
        reopenMobileFilterDrawerAfterClear = false;
        window.requestAnimationFrame(function() {
          if (theme.FilterDrawer) {
            theme.FilterDrawer.open();
          }
        });
      }
      if (typeof pendingDesktopFilterScroll !== 'number') {
        return;
      }
      setDesktopFilterScroll(pendingDesktopFilterScroll);
      pendingDesktopFilterScroll = undefined;
      if (!hasActiveCollectionFilters()) {
        releaseDesktopFilterHeight();
      }
      try {
        window.sessionStorage.removeItem(desktopFilterScrollKey);
      } catch (error) {
        return;
      }
    });
    window.addEventListener('resize', function() {
      if (!window.matchMedia('(min-width: 769px)').matches) {
        releaseDesktopFilterHeight();
      }
    }, { passive: true });
    document.addEventListener('page:loaded', init);
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
